import * as tslib_1 from "tslib";
import { OnInit, Renderer2 } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { BaseComponent } from '../core/components/bases/base-component';
export class BackendComponent extends BaseComponent {
    constructor(versionService, authService, userService, router, systemMessageService, spinnerService, renderer, canDeactivateService, titleService) {
        super();
        this.versionService = versionService;
        this.authService = authService;
        this.userService = userService;
        this.router = router;
        this.systemMessageService = systemMessageService;
        this.spinnerService = spinnerService;
        this.renderer = renderer;
        this.canDeactivateService = canDeactivateService;
        this.titleService = titleService;
        this.clazz = 'sidebar-hidden aside-menu-hidden';
        this.messages = [];
    }
    ngOnInit() {
        this.getCurrentUser();
        this.titleService.setTitle('Backend – TROFACO');
        this.spinnerService.setupShowOnBodyUntil(this.renderer, this.onDestroy$);
        this.systemMessageService.messages$.pipe(takeUntil(this.onDestroy$))
            .subscribe(message => this.messages = [...this.messages, message]);
        this.versionService.version().subscribe(version => this.version = version);
        const adminRoute = '/admin';
        if (this.router.url == adminRoute) {
            this.router.navigateByUrl('admin/plantingSites');
        }
    }
    onMessageClosed(message) {
        this.messages = this.messages.filter(m => m !== message);
    }
    logout(event) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (event)
                event.preventDefault();
            let success = yield this.router.navigateByUrl('/admin/login');
            //could fail if there's pending changes and the user cancels navigation
            if (!success)
                return;
            this.authService.removeToken();
            this.userService.removeUser();
        });
    }
    getCurrentUser() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.currentUser = yield this.userService.getCurrentUserAsync();
        });
    }
    unloadNotification($event) {
        if (!this.canDeactivateService.canDeactivate(false)) {
            $event.returnValue = true;
        }
    }
}
